import { render, staticRenderFns } from "./replay.vue?vue&type=template&id=1f83831c"
import script from "./replay.vue?vue&type=script&lang=js"
export * from "./replay.vue?vue&type=script&lang=js"
import style0 from "./replay.vue?vue&type=style&index=0&id=1f83831c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports